import { OfferSash } from '~/common/models';
import styles from './index.module.scss';
import React from 'react';

interface OfferSashProps {
  sash?: OfferSash;
}
export const OfferSashContent = React.memo<OfferSashProps>(({ sash }) => {
  return !!sash?.isVisible ? (
    <div
      className={styles.offerSash}
      style={{
        backgroundColor: sash.backgroundColor ?? '#000',
        color: sash.color ?? '#fff',
      }}
    >
      {sash.displayText}
    </div>
  ) : null;
});
